import {
  Component,
  ElementRef,
  EventEmitter, forwardRef,
  HostListener,
  Input,
  Output,
  ViewChild,
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { CtlRowEditSearchPopupComponent } from '../ctl-row-edit-search-popup/ctl-row-edit-search-popup.component';
import { DxButtonModule, DxTextBoxModule } from 'devextreme-angular';
import {
  ColumnCellTemplateData,
  ColumnEditCellTemplateData,
} from 'devextreme/ui/data_grid';
import { FilterDescriptor } from 'devextreme/data';
import { ClickEvent } from 'devextreme/ui/button';

@Component({
  selector: 'dk-ctl-row-edit-template',
  standalone: true,
  imports: [
    CommonModule,
    forwardRef(() => CtlRowEditSearchPopupComponent),
    DxTextBoxModule,
    DxButtonModule,
  ],
  templateUrl: './ctl-row-edit-template.component.html',
  styleUrls: ['./ctl-row-edit-template.component.scss'],
})
export class CtlRowEditTemplateComponent {
  @ViewChild(CtlRowEditSearchPopupComponent, { static: false })
  ctlRowEditSearchPopupComponent: CtlRowEditSearchPopupComponent;
  @Input() cellInfo: ColumnEditCellTemplateData;
  @Input() filterArr: FilterDescriptor | Array<FilterDescriptor>[];
  @Input() controlName: string;
  @Input() key: string = 'Kod';
  @Input() selectedValueDispName: string;
  @Input() startsWithFilterColumn: string;
  @Input() startsWithFilterColumnValue: any;
  @Input() dropDownWidth: number = 600;
  @Input() dropDownHeight: number = 600;
  @Input() textBoxReadOnly: boolean = false;
  @Output() afterClosePopup = new EventEmitter<{
    selectedRowData: any;
  }>();
  @Input() dataNotFoundText: string = 'Veri Bulunamadı!';
  @Input() showClearButtonTxtBox: boolean = false;
  @Output() txtBoxValueChange = new EventEmitter<string | number | null>();


  public visible: boolean = false;
  private isValueNumber: boolean = true;

  clearButtonOpt = {
    text: '',
    type: 'default',
    stylingMode: 'text',
    icon: 'clear',
    hint: 'Temizle',
    disabled:false,
    onClick: (e: ClickEvent) => {
      this.cellInfo.setValue(null);
      this.txtBoxValueChange.emit(null);
    },
  }

  constructor() {}

  ngOnInit() {
    this.isValueNumber = this.cellInfo.column.dataType == 'number';
  }

  textValueChange(e: any, cellInfo: ColumnEditCellTemplateData) {
    var valueWithType = this.isValueNumber ? Number(e?.value) : e?.value;
    if (e.value == '') {
      cellInfo.setValue(null);
      this.txtBoxValueChange.emit(null);
    } else if (valueWithType != e?.previousValue) {

      if(this.ctlRowEditSearchPopupComponent.control)

      this.isValueNumber
        ? cellInfo.setValue(Number(e?.value))
        : cellInfo.setValue(e?.value);

      this.isValueNumber
        ? this.txtBoxValueChange.emit( Number(e?.value) )
        : this.txtBoxValueChange.emit(  e?.value);
    }
  }

  closePopup(selectedRowData: any) {
    if (selectedRowData != 'close') {
      this.afterClosePopup.emit(selectedRowData);
    }
  }

}
